module.exports = __webpack_public_path__ + "static/media/irgb.17b7db05.svg";